<template>
  <b-container fluid>
    <!-- Modal Export Import RH -->
    <b-modal
      v-model="showModal"
      title="Import Data"
      ok-title="Submit"
      :loading="loadingImport"
      @ok="handleImportRh"
    >
      <template #modal-header>
        <h5 class="text-primary">Import Data</h5>
        <i class="fa fa-times cursor-pointer" @click="showModal = false"></i>
      </template>
      <template>
        <div class="flex flex-column align-items-center">
          <b-form-file
            v-model="importFile"
            type="file"
            class="form-control"
            accept=".xlsx, .xls, .csv"
          />
          <small class="text-black">accept: .xlsx, .xls, .csv</small>
        </div>
        <b-button
          v-if="!loadingExportTemplate"
          variant="outline-primary"
          class="mt-3 w-100"
          @click="handleExportTemplateRH"
        >
          <i class="fa fa-download"></i> Download Template
        </b-button>
        <b-button v-else variant="outline-primary" class="mt-3 w-100">
          <b-spinner style="width: 18px; height: 18px" class="mr-2"></b-spinner>
          Downloading
        </b-button>
      </template>
    </b-modal>
    <!-- End Modal Export Import RH -->

    <b-sidebar
      v-model="showCanvas"
      right
      width="80%"
      bg-variant="white"
      title="Add New Running Hours"
      header-class="p-0"
      shadow
      backdrop
    >
      <template #header>
        <div
          class="w-100 p-2 px-3 d-flex justify-content-between align-items-center"
          style="border-bottom: 1px solid; font-size: 18px; font-weight: 600"
        >
          <i class="fa fa-close cursor-pointer" @click="showCanvas = false"></i>
          <p class="m-0"
            >{{ selectedData ? 'Update' : 'Create' }} Running Hours</p
          ></div
        >
      </template>
      <template>
        <form-running-hours
          v-if="showCanvas"
          isFormDetail
          :selectedData="selectedData"
          @close="showCanvas = false"
          @refetch="fetchData"
          :fleetDetail="fleetDetail"
        />
      </template>
    </b-sidebar>
    <iq-card>
      <template #headerTitle>
        <h5 class="card-title text-primary">
          <strong>RUNNING HOUR - {{ fleetDetail?.name }}</strong>
        </h5>
      </template>
      <template #body>
        <b-row>
          <b-col md="6" class="mb-3 d-flex">
            <div class="d-flex">
              <date-picker
                range
                format="DD MMM YYYY"
                v-model="dateRange"
                value-type="DD-MM-YYYY"
                style="width: 240px"
              >
              </date-picker>
              <b-button variant="primary" class="mx-2" @click="fetchData"
                >Apply Filter
              </b-button>
            </div>
          </b-col>
          <b-col md="6" class="d-flex justify-content-end">
            <b-button
              variant="outline-primary"
              style="height: max-content"
              class="mr-2 d-flex align-items-center"
              @click="handleExportRh"
              :disabled="loadingExport"
            >
              <template v-if="!loadingExport">
                <i class="ri-download-2-line pl-1"></i>Export
              </template>
              <template v-else>
                <b-spinner small class="mr-2"></b-spinner>Exporting...
              </template>
            </b-button>
            <b-button
              variant="outline-primary"
              class="d-flex align-items-center"
              style="height: max-content"
              @click="showModal = true"
              ><i class="ri-upload-2-line pl-1"></i>Import</b-button
            >
            <b-button
              variant="outline-primary"
              class="mx-2"
              style="height: max-content"
              @click="$router.push('/maintenance/adjustment-running-hours')"
              >Adjustment Running Hours</b-button
            >
            <b-button
              variant="primary"
              style="height: max-content"
              @click="
                showCanvas = true
                selectedData = null
              "
              >Add Running Hours</b-button
            >
          </b-col>
          <b-col md="12">
            <table class="w-100 table-striped">
              <thead>
                <!-- <th>
                  <input
                    :checked="
                      runningHours?.every((el) => el.checked) &&
                      runningHours?.length
                    "
                    type="checkbox"
                    class="cursor-pointer"
                    @change="handleCheckAll"
                  />
                </th> -->
                <th>Action</th>
                <th>FLEET </th>
                <th>LAST DATE INPUT</th>
                <th>ENGINE NAME</th>
                <th>LAST INPUT RH</th>
                <th>TOTAL RH</th>
              </thead>
              <tbody v-if="!loading">
                <template v-for="(item, i) in runningHours">
                  <tr
                    v-for="(subItem, j) in item?.runningHours"
                    :key="`${i}-${j}`"
                  >
                    <!-- <td
                      class="bg-white"
                      v-if="j === 0"
                      :rowspan="item?.runningHours?.length"
                      style="border-bottom: 1px solid #dee2e6"
                    >
                      <input
                      type="checkbox"
                      class="mr-3 mb-0 cursor-pointer"
                      v-model="item.checked"
                      />
                    </td> -->
                    <td
                      class="bg-white"
                      v-if="j === 0"
                      :rowspan="item?.runningHours?.length"
                      style="border-bottom: 1px solid #dee2e6"
                    >
                      <b-dropdown
                        text="Action"
                        size="sm"
                        variant="outline-primary"
                      >
                        <b-dropdown-item
                          @click="
                            showCanvas = true
                            selectedData = item
                          "
                          >Update Running Hour</b-dropdown-item
                        >
                        <b-dropdown-item @click="() => handleDelete(item)"
                          >Delete Running Hour</b-dropdown-item
                        >
                      </b-dropdown>
                    </td>
                    <td
                      class="bg-white"
                      v-if="j === 0"
                      :rowspan="item?.runningHours?.length"
                      style="border-bottom: 1px solid #dee2e6"
                      ><b-badge
                        variant="success"
                        style="font-size: small"
                        class="px-3 py-2"
                        >{{ fleetDetail?.name }}</b-badge
                      ></td
                    >
                    <td
                      class="bg-white"
                      v-if="j === 0"
                      :rowspan="item?.runningHours?.length"
                      style="border-bottom: 1px solid #dee2e6"
                      >{{ formatDate(item?.date) }}</td
                    >
                    <td>{{ subItem?.powerType }}</td>
                    <td>{{ subItem?.dailyRunningHoursFormatted }}</td>
                    <td>{{ subItem?.totalRunningHoursFormatted ?? '-' }}</td>
                  </tr>
                </template>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="6">
                    <div class="w-100 d-flex justify-content-center py-5">
                      <b-spinner></b-spinner>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              class="mt-4 d-flex align-items-center w-100 justify-content-end"
            >
              <b-pagination
                class="mb-0 mr-3"
                @change="
                  (page) => {
                    meta.page = page
                    fetchData()
                  }
                "
                v-model="meta.page"
                :total-rows="meta.totalItems"
                :per-page="meta.limit"
                first-number
                align="center"
              ></b-pagination>
              <b-form-select
                plain
                v-model="meta.limit"
                :options="limitOptions"
                style="width: 140px"
                @input="fetchData"
              ></b-form-select>
            </div>
          </b-col>
        </b-row>
      </template>
    </iq-card>
  </b-container>
</template>
<script>
import { fleetsActions, maintenanceActions } from '@/src/Utils/helper'
import FormRunningHours from './FormRunningHours.vue'
import moment from '@/node_modules/moment/moment'
import { limitOptions } from '@/src/core/mock/data/optionsData'

export default {
  components: { FormRunningHours },
  name: 'MainPageRunningHourNewDetail',
  data() {
    return {
      loading: false,
      selectedData: null,
      showModalFilter: false,
      showCanvas: false,
      fleetDetail: null,
      runningHours: null,
      limitOptions: limitOptions,
      dateRange: [
        moment().startOf('year').format('DD-MM-YYYY'),
        moment().endOf('year').format('DD-MM-YYYY'),
      ],
      showModal: false,
      loadingImport: false,
      loadingExport: false,
      loadingExportTemplate: false,
      importFile: null,
      meta: {
        page: 1,
        limit: 10,
        totalItems: 10,
        totalPage: 1,
      },
    }
  },
  methods: {
    ...fleetsActions,
    ...maintenanceActions,
    async handleExportTemplateRH() {
      try {
        this.loadingExportTemplate = true
        const payload = {
          vehicleTypeId: this.fleetDetail?.vehicleType?.id,
        }
        const res = await this.exportTemplateRunningHoursV2(payload)
        saveAs(res.data, 'template_running_hours.xlsx')
        this.$swal({
          title: 'Download Template Success',
          text: res.message,
          icon: 'success',
        })
      } catch (error) {
        console.log(error)
        this.$swal({
          title: 'Failed Data Success',
          icon: 'error',
        })
      } finally {
        this.loadingExportTemplate = false
      }
    },
    async handleExportRh() {
      try {
        this.loadingExport = true
        const params = {
          start_date: this.dateRange[0],
          end_date: this.dateRange[1],
        }
        const res = await this.exportRunningHoursV2({vehicleId: this.$route.params.id, params})
        saveAs(res.data, `${this.fleetDetail?.name}_running_hours.xlsx`)
        this.$swal({
          title: 'Success Export Data',
          icon: 'success',
        })
      } catch (error) {
        console.log(error)
        this.$swal({
          title: 'Failed Export Data',
          icon: 'error',
        })
      } finally {
        this.loadingExport = false
      }
    },
    async handleImportRh() {
      try {
        this.loadingImport = this.msgErrImport = []
        const formData = new FormData()
        formData.append('file', this.importFile)
        const res = await this.importRunningHoursV2(formData)
        this.$swal({
          title: 'Import Data Success',
          icon: 'success',
        })
      } catch (error) {
        console.log(error)
        this.$swal({
          title: 'Failed Import Data!',
          type: 'error',
          text: 'Failed Import Data please check your file import!',
          icon: 'error',
          // didClose: () => {
          //   this.showErrImport = true
          // },
        })
      } finally {
        this.loadingImport = false
        this.fetchData()
      }
    },
    formatDate(date) {
      return date ? moment(date, 'DD-MM-YYYY').format('DD MMM YYYY') : '-'
    },
    async fetchData() {
      this.loading = true
      const params = {
        vehicleId: this.$route.params?.id,
        startDate: this.dateRange[0],
        endDate: this.dateRange[1],
        ...this.meta,
      }
      const res = await this.getRunningHoursByVehilceIdV2(params)
      if (res?.status === 'success') {
        this.runningHours = res.data?.data?.map((item) => ({
          ...item,
          checked: false,
        }))
      } else {
        console.log(res)
      }
      this.loading = false
    },
    async fetchFleetDetail(id) {
      const res = await this.getFleetById(this.$route.params.id)
      if (res?.status === 'success') {
        this.fleetDetail = res.data
      } else {
        this.$swal(`Oops!`, res.data, 'error')
      }
    },
    handleCheckAll(e) {
      const { checked } = e.target
      this.runningHours.forEach((item) => {
        item.checked = checked
      })
    },
    handleDelete(data) {
      this.$swal({
        title: 'Delete Data?',
        text: `Data will be deleted and cannot be recovered.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Delete',
      }).then(async (result) => {
        if (result.isConfirmed) {
          let res = await this.deleteRunningHours({
            vehicleId: this.fleetDetail?.id,
            date: data?.date,
          })
          if (res.status !== 'success') {
            this.$swal(
              'Error',
              res.data.message ??
                'Something wrong with the server. Cannot get user data.',
              'error'
            )
          } else {
            this.fetchData()
            this.$swal(`Data deleted!`, 'success')
          }
        }
      })
    },
  },
  mounted() {
    this.fetchFleetDetail()
    this.fetchData()
  },
}
</script>

<style scoped>
table th {
  padding: 8px 12px;
}
table td {
  padding: 8px 12px;
  color: black;
}
</style>
